module.exports = __webpack_public_path__ + "media/images/icon-cancel-fill-02e893cec0c33acf52ac4fec394622c5.svg";